import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class VendorAvEquipmentService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/vendors/%(id)s/av_equipments`);
  }

  sync(vendorId: any, avEquipmentIds: any[]): Observable<any> {
    const url = sprintf(this.baseUrl, { id: vendorId }) + '/sync';
    return this.http.put<any>(url, { av_equipment_ids: avEquipmentIds });
  }
}
